// extracted by mini-css-extract-plugin
export default {"emptyMessage":"VpIYiC0N_zI68pJPQjAz","clientName":"vNExezBIPJgSbyoslosS"};